import { inlineAtomNode } from '#src/tiptap/nodes/shared.ts'

export const InsertConditionsButtonNode = inlineAtomNode(
  'insert-conditions-button',
  'button',
  { display: { isDisplay: true } }
)
